import { render } from "./joint.vue?vue&type=template&id=0eda6d50&scoped=true"
import script from "./joint.vue?vue&type=script&lang=js"
export * from "./joint.vue?vue&type=script&lang=js"

import "./joint.vue?vue&type=style&index=0&id=0eda6d50&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eda6d50"]])

export default __exports__